// extracted by mini-css-extract-plugin
export default {"arrow":"Arrow-module--arrow--23424","iconBlock":"Arrow-module--iconBlock--3b275"};